import { useFeatureFlag } from '../../../../utils/FeatureFlag';
import { Flags } from '@watershed/constants/flags';

/**
 * Uses feature flags to dictate whether to show product footprints.
 */
export function useShowProductFootprints(): {
  showPfScope3: boolean;
  showPfProductFootprints: boolean;
} {
  const hasPfScope3SkuEnabled = useFeatureFlag(Flags.ProductFootprintsScope3);
  const hasPfProductFootprintsSkuEnabled = useFeatureFlag(
    Flags.ProductFootprintsProductFootprints
  );
  return {
    showPfScope3: hasPfScope3SkuEnabled,
    showPfProductFootprints:
      hasPfScope3SkuEnabled && hasPfProductFootprintsSkuEnabled,
  };
}
